import React from "react";
import styles from "../styles/modal.module.scss";

export default function UsersTableSkeleton({ rows = 6, columns = 4 }) {
  return (
    <div className={styles.tableWrap} aria-hidden="true">
      <table className={styles.dataTable}>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {Array.from({ length: columns }).map((__, colIndex) => (
                <td key={colIndex}>
                  <div
                    className={styles.skeletonLine}
                    style={{
                      width: colIndex === 0 ? "70%" : "46%",
                    }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
